export const Logo = ({ size = 36, testId = "brand-logo" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 48 48"
    fill="none"
    data-testid={testId}
    aria-hidden="true"
  >
    <circle cx="24" cy="24" r="21" stroke="var(--ns-gold)" strokeOpacity="0.4" strokeWidth="1.2" />
    <circle cx="24" cy="24" r="14.5" stroke="var(--ns-gold)" strokeOpacity="0.18" strokeWidth="0.8" />
    <path
      d="M24 5 L27.4 20.6 L43 24 L27.4 27.4 L24 43 L20.6 27.4 L5 24 L20.6 20.6 Z"
      fill="url(#ns-star-gradient)"
    />
    <circle cx="24" cy="24" r="2.2" fill="#FFF7E8" />
    <defs>
      <linearGradient id="ns-star-gradient" x1="5" y1="5" x2="43" y2="43">
        <stop stopColor="#F3C98A" />
        <stop offset="0.55" stopColor="#E2A85C" />
        <stop offset="1" stopColor="#F59E0B" />
      </linearGradient>
    </defs>
  </svg>
);
